import React, { useEffect, useMemo, useState } from "react";
import { ToggleSwitch } from "../../form-inputs/inputs";

export const BrightRiverShotItem = ({ name, originalImgUrl, editedImgUrl, imageDescription, onCorrectionUpdate, forceChecked, locale }) => {
    const [isToggled, setToggle] = useState(false);
    const id = useMemo(() => Date.now(), []);

    useEffect(() => {
        onCorrectionUpdate(name, isToggled);
    }, [isToggled, name]);

    useEffect(() => {
        if (forceChecked !== undefined) {
            setToggle(forceChecked);
        }
    }, [forceChecked]);

    return (
        <div className="br-redo-modal-item">
            <div className="br-modal-photos">
                <h4>
                    {imageDescription} <span className="memo">({locale})</span>
                </h4>
                <div className="photos-container">
                    <div className="photo">
                        <img
                            alt={`Product ${imageDescription || "Coding"}`}
                            src={originalImgUrl ? `${originalImgUrl}?v=${id}` : ""}
                        />
                        <div className="txt-bold">Unedited</div>
                    </div>
                    <div className="photo">
                        <img
                            alt={`Product ${imageDescription || "Coding"}`}
                            src={editedImgUrl ? `${editedImgUrl}?v=${id}` : ""}
                        />
                        <div className="txt-bold">Edited</div>
                    </div>
                </div>
            </div>
            <div className="br-modal-switch">
                <ToggleSwitch
                    name={name}
                    value={isToggled}
                    label={isToggled ? "Send" : "Don't send"}
                    testid={`${name}_id`}
                    updateOnChange={(switchName, value) => setToggle(value)}
                />
            </div>
        </div>
    );
};
